export enum ErrorClassification {
    TechnicalError,
    FunctionalError
}
